// @ts-strict-ignore
import {Component, Injector, OnInit} from "@angular/core";
import {ConfirmationParticipantDto, ParticipantState} from "@models";
import {Translations} from "@translations";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";

export interface DialogData_ParticipantConfirmationDialogInput extends MatDialogDataBaseInput {
	participantDetails: ConfirmationParticipantDto;
	isReadOnlyMode: boolean;
}

export interface DialogData_ParticipantConfirmationDialogOutput extends MatDialogDataBaseOutput {
	result?: ParticipantState;
}

@Component({
	selector: "sim-participant-confirmation-dialog",
	templateUrl: "./participant-confirmation-dialog.component.html",
	styleUrl: "./participant-confirmation-dialog.component.scss",
	standalone: false,
})
export class ParticipantConfirmationDialogComponent
	extends BasicMaterialDialog<
		ParticipantConfirmationDialogComponent,
		DialogData_ParticipantConfirmationDialogInput,
		DialogData_ParticipantConfirmationDialogOutput
	>
	implements OnInit
{
	// Properties
	public participantDetails: ConfirmationParticipantDto;
	public isReadOnlyMode = true;

	// Readonly
	public readonly T = Translations;
	protected readonly ParticipantState = ParticipantState;

	public constructor(_injector: Injector) {
		super(_injector);
	}

	public ngOnInit() {
		super.ngOnInit();
		this.participantDetails = this.data.participantDetails;
		this.isReadOnlyMode = this.data.isReadOnlyMode;
	}
}
